import { render, staticRenderFns } from "./RouteWrapper.vue?vue&type=template&id=52001800&"
import script from "./RouteWrapper.vue?vue&type=script&lang=js&"
export * from "./RouteWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52001800')) {
      api.createRecord('52001800', component.options)
    } else {
      api.reload('52001800', component.options)
    }
    module.hot.accept("./RouteWrapper.vue?vue&type=template&id=52001800&", function () {
      api.rerender('52001800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/RouteWrapper.vue"
export default component.exports